import type { ExtractUsageInputResult } from "./extractUsageInput.js";
import type { AiCostExtraction, AiCostResult, AiUsageInput } from "./types.js";

export function toCostExtraction(
  provenance: ExtractUsageInputResult["provenance"],
): AiCostExtraction {
  return {
    model: { field: provenance.model.field, path: provenance.model.path },
    tokens: {
      source: provenance.tokens.source,
      path: provenance.tokens.path,
      estimated: provenance.tokens.estimated,
    },
    ...(provenance.modelUsed
      ? {
          modelUsed: {
            field: provenance.modelUsed.field,
            path: provenance.modelUsed.path,
          },
        }
      : {}),
    ...(provenance.provider
      ? {
          provider: {
            field: provenance.provider.field,
            path: provenance.provider.path,
          },
        }
      : {}),
  };
}

/** Attach usage, provider, and model fields callers expect on every cost response. */
export function enrichCostResult(
  result: Omit<
    AiCostResult,
    "usage" | "provider" | "usedModel" | "model" | "extraction"
  >,
  input: AiUsageInput,
  extraction?: AiCostExtraction,
): AiCostResult {
  /** Original model id from the caller — never replaced by catalog resolution. */
  const receivedModelId = input.usedModel ?? input.modelUsed ?? input.model;

  return {
    ...result,
    provider: input.provider,
    usage: { ...input.tokens },
    ...(receivedModelId ? { usedModel: receivedModelId } : {}),
    ...(input.model && input.model !== receivedModelId ? { model: input.model } : {}),
    ...(extraction ? { extraction } : {}),
  };
}
